<template>
  <td>
    {{getNewsTypeText(newsType)}} 
    <template v-if="newsType === 'CUSTOM'">
      <br v-if="!singleLine" />
      <span style="color: #0387ca;">[{{getCustomNewsText(customNewsType, short)}}]</span>
    </template>
  </td>
</template>

<script>
import newsMixin from "$views/News/_mixin";

export default {
  props: {
    newsType: String,
    customNewsType: String,
    singleLine: Boolean,
    short: Boolean
  },
  mixins: [newsMixin]
};
</script>

<style>
</style>